import { Card, Spin } from "antd";
import ErrorWidget from "components/Widgets/ErrorWidget";
import WizardHeader from "modules/components/WizardHeader";
import React from "react";
import { useSelector } from "react-redux";
import { StepThankYou, StepThankYouProject } from "../../common/steps";
import useInitAvenant from "../useInitAvenant";
import { StepDetails, StepImmatriculation } from "./steps";
import * as helpers from 'helpers/helpers';
import { useBasket } from "views/pages/subscription/hooks/useBasket";
import { useState } from "react";
import { useEffect } from "react";
import QuotationService from "services/quotationService";
import _ from "lodash";
import QuotationResponse from "api/v1/response/QuotationResponse";

export default function AvenantChangementImmatriculation() {
    const { avenant, contract, category, partnerCode } = useSelector((state) => state.subscription);
    const { currentStep, page, basket, transactionResponse, initAvenantResponse } = useSelector((state) => state.basketSlice);
    const { updateGroup} = useBasket();
    const { state } = useInitAvenant()

    useEffect(()=> {
        if(!state.isInitAvenantLoading) {
            const _packSelected = _.first(basket?.quotationResponse?.packsResponse);
            const _subscriptionRequest = {
                ...basket?.subscriptionRequest,
                primeTTC: basket?.quotationResponse?.primeTTC,
                primeExtra: basket?.quotationResponse?.primeExtra,
                primeNette: basket?.quotationResponse?.primeNette,
                extras: basket?.quotationResponse?.extras || []
            }
            updateGroup([
                { path: ['basket', 'packSelected'], value: { ..._packSelected } },
                { path: ['basket', 'subscriptionRequest'], value: { ..._subscriptionRequest } },
            ])
        }
        
    }, [state.isInitAvenantLoading])

    if (state?.isInitAvenantLoading) {
        return <Card><Spin /> Chargement et configuration en cours ...</Card>
    }

    if (state?.iniAvenantLoadingError) {
        return <ErrorWidget errorMessage={state?.iniAvenantLoadingErrorMessage} />;
    }

    function renderChildren() {
        switch (currentStep) {
            case 0:
                return <StepImmatriculation basket={basket} oldMAtriculation={basket?.subscriptionRequest?.vehicle?.matriculation} />;
            case 1:
                return <StepDetails
                            avenantCode={avenant?.code}
                            endDate={initAvenantResponse?.endDate}
                            subscriptionRequest={basket?.subscriptionRequest}
                            packSelected={basket?.packSelected}
                            />
            case 2:
                if (page === helpers.PAGES.THANK_YOU) {
                    return <StepThankYou transactionResponse={transactionResponse} />;
                }

                if (page === helpers.PAGES.PROJECT_THANK_YOU) {
                    return <StepThankYouProject transactionResponse={transactionResponse} />;
                }
                break;
            default:
                return <ErrorWidget errorMessage="Ooops ! la page n'existe pas" />;
        }
    }

    return (

        <React.Fragment>
            <WizardHeader
                title={`Categorie ${category.code} : ${category.title}`}
                avenantTilte={`Avenant d'immatriculation `}
                partnerCode={partnerCode}
                police={contract?.policeNumber}
                //onClick={(state.currentStep > 0 && state.currentStep < 4) ? goToPreviousStep : null}
                percent={currentStep * 50}
            />
            {renderChildren()}
        </React.Fragment>
    )
}